"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractWitness = void 0;
var ContractId_1 = require("../ContractId");
var StateCommitment_1 = require("../StateCommitment");
var __1 = require("../../..");
var Serialization_1 = require("../../../Handlers/Serialization");
var lodash_1 = require("lodash");
var Witness_1 = require("./Witness");
var BigInteger = require("bigi");
var ContractWitness = /** @class */ (function (_super) {
    __extends(ContractWitness, _super);
    function ContractWitness(contractId, command, stateCommitment, beginInputs, beginOutputs, inputsLength, outputsLength, cost, messageBody, signature) {
        var _this = _super.call(this, Witness_1.WitnessType.ContractWitness) || this;
        _this.contractId = contractId;
        _this.command = command;
        _this.stateCommitment = stateCommitment;
        _this.beginInputs = beginInputs;
        _this.beginOutputs = beginOutputs;
        _this.inputsLength = inputsLength;
        _this.outputsLength = outputsLength;
        _this.cost = cost;
        _this.messageBody = messageBody;
        _this.signature = signature;
        return _this;
    }
    ContractWitness.read = function (buffer, offset) {
        var _a = Serialization_1.readVarInt(buffer, offset), count = _a.value, offset1 = _a.offset;
        offset = offset1;
        var _b = ContractId_1.ContractId.read(buffer, offset), contractId = _b.contractId, offset2 = _b.offset;
        var _c = Serialization_1.readString(buffer, offset2), command = _c.value, offset3 = _c.offset;
        var messageBody = undefined;
        var isMessageBody = buffer.readInt8(offset3);
        offset = offset3 + 1;
        if (isMessageBody === 1) {
            var _d = __1.DataFactory.read(buffer, offset), data = _d.data, offset4 = _d.offset;
            offset = offset4;
            messageBody = data;
        }
        var _e = StateCommitment_1.StateCommitment.read(buffer, offset), stateCommitment = _e.stateCommitment, offset5 = _e.offset;
        var _f = Serialization_1.readVarInt(buffer, offset5), beginInputs = _f.value, offset6 = _f.offset;
        var _g = Serialization_1.readVarInt(buffer, offset6), beginOutputs = _g.value, offset7 = _g.offset;
        var _h = Serialization_1.readVarInt(buffer, offset7), inputsLength = _h.value, offset8 = _h.offset;
        var _j = Serialization_1.readVarInt(buffer, offset8), outputsLength = _j.value, offset9 = _j.offset;
        var signaturePair = undefined;
        var isSignature = buffer.readInt8(offset9);
        offset = offset9 + 1;
        if (isSignature === 1) {
            var publicKey = buffer.slice(offset, offset + 33);
            offset += 33;
            var signature = buffer.slice(offset, offset + 64);
            offset += 64;
            signaturePair = [publicKey, signature];
        }
        var cost = buffer.slice(offset, offset + 8);
        offset += 8;
        var witness = new ContractWitness(contractId, command, stateCommitment, beginInputs, beginOutputs, inputsLength, outputsLength, cost, messageBody, signaturePair);
        if (witness.getPayloadSize() !== count)
            throw new Error('wtf');
        return { witness: witness, offset: offset };
    };
    ContractWitness.prototype.toJson = function () {
        return {
            identifier: this.identifier,
            contractId: this.contractId.toHex(),
            command: this.command,
            stateCommitment: this.stateCommitment.toJson(),
            beginInputs: this.beginInputs,
            beginOutputs: this.beginOutputs,
            inputsLength: this.inputsLength,
            outputsLength: this.outputsLength,
            cost: BigInteger.fromBuffer(this.cost).toString(10),
            messageBody: this.messageBody,
            signature: {
                pk: this.signature ? this.signature[0].toString('hex') : '',
                sign: this.signature ? this.signature[1].toString('hex') : ''
            }
        };
    };
    ContractWitness.prototype.getPayloadSize = function () {
        return this.contractId.getSize() +
            Serialization_1.getSizeOfString(this.command) +
            1 + (lodash_1.isUndefined(this.messageBody) ? 0 : this.messageBody.getSize()) +
            this.stateCommitment.getSize() +
            Serialization_1.getSizeOfVarInt(this.beginInputs) +
            Serialization_1.getSizeOfVarInt(this.beginOutputs) +
            Serialization_1.getSizeOfVarInt(this.inputsLength) +
            Serialization_1.getSizeOfVarInt(this.outputsLength) +
            1 + (lodash_1.isUndefined(this.signature) ? 0 : this.signature[0].length + this.signature[1].length)
            + 8; // cost
    };
    ContractWitness.prototype.getSize = function () {
        var payload = this.getPayloadSize();
        return _super.prototype.getSize.call(this) + Serialization_1.getSizeOfVarInt(payload) + payload;
    };
    ContractWitness.prototype.write = function (buffer, offset) {
        offset = Serialization_1.writeVarInt(2, buffer, offset);
        offset = Serialization_1.writeVarInt(this.getPayloadSize(), buffer, offset);
        offset = this.contractId.write(buffer, offset);
        offset = Serialization_1.writeString(this.command, buffer, offset);
        if (lodash_1.isUndefined(this.messageBody)) {
            offset = buffer.writeUInt8(0, offset);
        }
        else {
            offset = buffer.writeUInt8(1, offset);
            offset = this.messageBody.write(buffer, offset);
        }
        offset = this.stateCommitment.write(buffer, offset);
        offset = Serialization_1.writeVarInt(this.beginInputs, buffer, offset);
        offset = Serialization_1.writeVarInt(this.beginOutputs, buffer, offset);
        offset = Serialization_1.writeVarInt(this.inputsLength, buffer, offset);
        offset = Serialization_1.writeVarInt(this.outputsLength, buffer, offset);
        if (lodash_1.isUndefined(this.signature)) {
            offset = buffer.writeUInt8(0, offset);
        }
        else {
            offset = buffer.writeUInt8(1, offset);
            offset = offset + this.signature[0].copy(buffer, offset);
            offset = offset + this.signature[1].copy(buffer, offset);
        }
        offset = offset + this.cost.copy(buffer, offset);
        return offset;
    };
    return ContractWitness;
}(Witness_1.Witness));
exports.ContractWitness = ContractWitness;
//# sourceMappingURL=ContractWitness.js.map